/**
 * CDN Utility for Frontend
 * Handles CDN URL generation for images and assets
 */
import { getBaseUrl } from './apiUrl';

const getCDNUrl = (path) => {
  if (!path) return '';
  
  // If already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Get CDN URL from environment
  const cdnUrl = process.env.REACT_APP_CDN_URL || '';
  
  // If CDN URL is set, prepend it
  if (cdnUrl && path.startsWith('/')) {
    return `${cdnUrl}${path}`;
  }
  
  // If no CDN URL, use backend URL (for both dev and production)
  if (!cdnUrl) {
    const baseUrl = getBaseUrl();
    return path.startsWith('/') ? `${baseUrl}${path}` : path;
  }

  return path;
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return '';
  }
  const url = getCDNUrl(imagePath);
  return url;
};

export default getCDNUrl;

